import { Logger } from "../utils/logger";
import { dataAttributePrefix, formSubmissionCookieName } from "../index";
import { Base64 } from "../utils/base64";
import { Cookies } from "../utils/cookies";
import EventEmitter from "events";
import { DOMUtils } from "../utils/dom";
import { DataTrackingClient } from "../core";
export class BindTargetFrameResult {
    constructor() {
        this.success = false;
        this.isTargetFrame = false;
    }
}
export class FormSubmissionMonitor {
    constructor() {
        this._dataAttributePrefix = dataAttributePrefix;
        this._emitter = new EventEmitter();
        if (FormSubmissionMonitor._instance) {
            throw new Error("Singleton class [FormSubmissionMonitor] can't be instantiated more than once. Call getInstance() instead");
        }
    }
    onSubmit(callBack) {
        this._emitter.on("submit", (formSubmissionData) => {
            callBack.call(this, formSubmissionData);
        });
    }
    static getInstance() {
        if (!FormSubmissionMonitor._instance) {
            FormSubmissionMonitor._instance = new FormSubmissionMonitor();
        }
        return FormSubmissionMonitor._instance;
    }
    overideSubmitMethod() {
        Logger.verbose("Overriding form submit()");
        ((originalSubmitMethod, objFormSubmissionMonitor) => {
            HTMLFormElement.prototype.submit = function () {
                Logger.debug("submit() called on Form element");
                Logger.verbose(this);
                originalSubmitMethod.call(this);
                // Get the tracking element id from the form tag. It is already bound during DOMElementEventMonitor::init()
                let elementId = this.getAttribute(dataAttributePrefix + "element-id");
                if (!elementId) {
                    Logger.error(this._dataAttributePrefix + "element-id data attribute not found on FormElement");
                    return;
                }
                // Get the item from trackElements array based on the elementId
                let trackingItem = DataTrackingClient.getInstance().getTrackingElementById(parseInt(elementId));
                if (trackingItem == null) {
                    Logger.error("Element with id (" + elementId + ") not found in elements array");
                    Logger.verbose(this._tackingElements);
                    return;
                }
                Logger.debug("Form submission detected. Attaching monitor.");
                objFormSubmissionMonitor.monitor(this, trackingItem);
            };
        })(HTMLFormElement.prototype.submit, this);
    }
    monitor(formElement, trackingItem) {
        // In case of a form element, which gets sbumitted through an iframe
        // We'll attach an onload handler to the iframe to capture and process the content of response
        // After the iframe content is loaded.
        let bindFrameResult = new BindTargetFrameResult();
        this._bindFormTargetFrameLoadIfRequired(formElement, bindFrameResult);
        const data = new FormData(formElement);
        let attributeData = {};
        let propertyData = {};
        let cookieData = {};
        if (trackingItem.trackingAttributes) {
            for (let j = 0; j < trackingItem.trackingAttributes.length; j++) {
                attributeData[trackingItem.trackingAttributes[j]] = formElement.getAttribute(trackingItem.trackingAttributes[j]);
            }
        }
        if (trackingItem.trackingProperties) {
            for (let j = 0; j < trackingItem.trackingProperties.length; j++) {
                propertyData[trackingItem.trackingProperties[j]] = DOMUtils.getProperty(formElement, trackingItem.trackingProperties[j]);
            }
        }
        if (trackingItem.trackingCookies) {
            for (let j = 0; j < trackingItem.trackingCookies.length; j++) {
                cookieData[trackingItem.trackingCookies[j]] = Cookies.getCookie(trackingItem.trackingCookies[j], false);
            }
        }
        var obj = {
            trackingItem: trackingItem,
            formData: Object.fromEntries(data.entries()),
            successText: trackingItem.formConfig.successText,
            isFrameBasedSubmission: bindFrameResult.isTargetFrame && bindFrameResult.success,
            attributeData: attributeData,
            propertyData: propertyData,
            cookieData: cookieData
        };
        Logger.debug("Creating form submission cookie");
        Logger.verbose(obj);
        let formConfigData = trackingItem.formConfig;
        let condition = false;
        condition = (trackingItem.whatToTrack == "form");
        condition = (condition && trackingItem.formConfig);
        condition = (condition && formConfigData.submitType == "normal");
        condition = condition && (formConfigData.successText == null || formConfigData.successText == '');
        condition = condition && (formConfigData.successURL == null || formConfigData.successURL == '');
        if (condition) {
            Logger.debug("Form submit tracking event triggered - without cookie & submission status checking", obj);
            this._emitter.emit("submit", obj);
        }
        else {
            Cookies.createCookie(formSubmissionCookieName, Base64.encode(JSON.stringify(obj)));
        }
    }
    _bindFormTargetFrameLoadIfRequired(formElement, result) {
        result.isTargetFrame = false;
        result.success = true;
        var formTarget = formElement.getAttribute("target");
        if (formTarget && formTarget != "") {
            /* if the form target is not any of the defaults, then it must be an iframe */
            if (["_blank", "_self", "_parent", "_top"].indexOf(formTarget) < 0) {
                Logger.debug("Form is set to submit through a frame. Hooking to frame's load event");
                let iframe = document.querySelector("iframe[name='" + formTarget + "']");
                Logger.verbose("Fninding frame with selector iframe[name='" + formTarget + "']");
                Logger.verbose(iframe);
                if (iframe) {
                    // Check if the we already have hooked to the load event of this iframe
                    let bounded = iframe.getAttribute(this._dataAttributePrefix + "-load-bounded");
                    if (!bounded) {
                        // If not hooked, then attach the listener and set the data attribute on the iframe
                        iframe.setAttribute(this._dataAttributePrefix + "-load-bounded", "true");
                        iframe.addEventListener("load", (e) => {
                            // var html = e.target.contentWindow.document.documentElement.innerHTML;							
                            const windowContent = e.target.contentWindow || e.target.contentDocument;
                            const document = windowContent.document ? windowContent.document : windowContent;
                            var html = document.body.innerHTML;
                            Logger.debug("Form target frame loaded");
                            Logger.verbose(html);
                            this.checkFormSubmissionStatus(html);
                        });
                    }
                }
                else {
                    Logger.error("Form's target frame not found in DOM. Form will be sumitted normally on same window.");
                    result.isTargetFrame = true;
                    result.success = false;
                }
            }
        }
    }
    checkFormSubmissionStatus(content) {
        Logger.debug("Checking if form submission cookie exist");
        var formSubmissionCookieValue = Cookies.getCookie(formSubmissionCookieName);
        if (!formSubmissionCookieValue) {
            Logger.debug("Form submission cookie does not exist. Returning");
            return;
        }
        Logger.verbose(formSubmissionCookieValue);
        let objFormSubmissionData;
        try {
            objFormSubmissionData = JSON.parse(Base64.decode(formSubmissionCookieValue));
        }
        catch (_a) {
            Logger.error("Failed to decode form submission cookie");
            return;
        }
        Logger.verbose("Form submission cookie");
        Logger.verbose(objFormSubmissionData);
        if (!objFormSubmissionData) {
            Logger.debug("Form submission cookie is empty. This is not expected. Returning");
            return;
        }
        if (content.indexOf(objFormSubmissionData.successText) >= 0) {
            Logger.debug("Form success text found in content");
            this._emitter.emit("submit", objFormSubmissionData);
        }
        else {
            Logger.debug("Form success text is not found in content");
        }
        Logger.verbose("Removing form submission cookie");
        Cookies.deleteCookie(formSubmissionCookieName);
    }
}
FormSubmissionMonitor._instance = null;
